import { pick } from 'lodash';
// extract necessary fetchOptions from config
// https://fetch.spec.whatwg.org/#requestinit
const extracts = [
    'method',
    'headers',
    'body',
    'referrer',
    'mode',
    'credentials',
    'cache',
    'redirect',
    'integrity',
    'window'
];
const agent = (function () {
    let agent;
    if (__SERVER__) {
        // tslint:disable-next-line: no-require-imports
        const Agent = require('http').Agent;
        agent = new Agent({ keepAlive: true, maxSockets: 24 });
    }
    return agent;
})();
export const pickFetchOptions = (context) => {
    const fetchOptions = pick(context, extracts);
    if (__SERVER__) {
        fetchOptions.agent = fetchOptions.agent || agent;
    }
    if (context.body) {
        // TODO: Assert the type conversion of body between TRequestBody and
        // BodyInit. ApiCaller only accepts strings and plain objects
        // (JSON-serializable) as body parameters, but BodyInit accepts more
        // types like ReadableStream and as such will require a type conversion
        // somewhere to avoid type errors. Remove the `as` after that.
        fetchOptions.body = context.body;
    }
    return fetchOptions;
};
